export const forecast = {
  zh: {
    pastData: "過去數據",
    minForecast: "最小預測",
    avgForecast: "平均預測",
    maxForecast: "最大預測",
  },
  en: {
    pastData: "Past Data",
    minForecast: "Min Forecast",
    avgForecast: "Avg. Forecast",
    maxForecast: "Max Forecast",
  },
};
